import { compileTagCatalog, type TagGroupDefinition } from "./TagCatalogUtils";

export const TagCatalog = {
  Portal: {
    prefix: "VirtualTags:Portal",
    groups: {
      Inverter: {
        prefix: "Inverter",
        tags: ["AcPower", "DcPower", "SystemStatus"],
      },
      PowerMeter: {
        prefix: "PowerMeter",
        tags: ["AggrStatus"],
      },
      DailyProduction: {
        prefix: "DailyProduction",
        tags: ["AcPower", "DcPower", "Potential", "Sp"],
      },
      DailyIrradiance: {
        prefix: "DailyIrradiance",
        tags: ["CalibratedGHI"],
      },
      PerformanceModel: {
        prefix: "PerformanceModel",
        tags: ["PotentialPowerProduction", "ContractPowerProduction"],
      },
      TrackerStatus: {
        prefix: "TrackerStatus",
        tags: ["SystemStatus"],
      },
      Weather: {
        prefix: "Weather",
        tags: ["WindSpeed", "AggrStatus"],
      },
      System: {
        prefix: "System",
        tags: ["FieldState", "SafetyReason"],
      },
    },
  },
  Weather: {
    prefix: "Weather",
    tags: [
      "RelativeHumidity",
      "BarometricPressure",
      "WindDirection",
      "GlobalIrradiance",
      "AmbientAirTemp",
      "PlaneOfArrayIrradiance",
      "ErrorType",
      "BackOfModuleTemp",
      "TemperatureCompensatedRadiation",
      "SoilingRatio",
      "EstimatedDni",
    ],
  },
  McsState: {
    prefix: "McsState",
    tags: [
      "State",
      "UpsEmergencyStatus",
      "TcmFirmwareAutoUpdateMode",
      "TimeToNextAutoFWUpdate",
      "EngineerEmergencyStatus",
      "CloudEmergencyStatus",
      "WindForecastEmergencyStatus",
    ],
  },
  TrackerStatus: {
    prefix: "TrackerStatus",
    tags: [
      "CurrentState",
      "TargetState",
      "TrackerAutoFirmwareUpdateStatus",
      "Uptime",
      "ShadingRatio",
      "CurrentElevation",
      "ErrorType",
      "InputPotential",
      "BatteryVoltage",
      "TargetElevation",
    ],
  },
  Trackers: {
    prefix: "VirtualTags:Trackers",
    groups: {
      StateCount: {
        prefix: "StateCount",
        tags: ["Tracking", "Maintenance"],
      },
    },
  },
  Inverter: {
    prefix: "Inverter",
    tags: ["ErrorType", "InternalAirTemperature"],
  },
  PowerMeter: {
    prefix: "PowerMeter",
    tags: ["ProductionDelta", "ProductionTotal", "ErrorType", "AggrStatus"],
  },
  CleaningFaucetOpeningRatio: {
    prefix: "CleaningFaucetOpeningRatio",
    tags: ["OpeningRatio"],
  },
  VirtualWeather: {
    prefix: "VirtualTags:Weather",
    tags: ["CalibratedGHI"],
  },
  Performance: {
    prefix: "VirtualTags:Performance",
    tags: ["PerformanceIndex"],
  },
  FrontendCalculated: {
    prefix: "FrontendCalculated",
    tags: ["CurrentPerformanceIndex"],
  },
  Agriculture: {
    prefix: "Agri",
    tags: [
      "SoilTemperature",
      "SoilHumidity",
      "SoilPH",
      "StemGrowth",
      "PlantPhotosyntheticallyActiveRadiationPpfd",
      "RainFall",
      "SoilNitrogen",
      "SoilPhosphorus",
      "SoilPotassium",
      "SoilConductivity",
      "SoilSalinity",
      "SoilHumidityLayer1",
      "SoilHumidityLayer2",
      "SoilHumidityLayer3",
      "SoilHumidityLayer4",
      "SoilHumidityLayer5",
      "SoilTemperatureLayer1",
      "SoilTemperatureLayer2",
      "SoilTemperatureLayer3",
      "SoilTemperatureLayer4",
      "SoilTemperatureLayer5",
    ],
  },
} as const satisfies Record<string, TagGroupDefinition>;

export const Tags = compileTagCatalog(TagCatalog);
